const Disk = () => import('views/diskm/Disk')
const DiskPhoto = () => import('views/diskm/DiskPhoto')
const DiskMe = () => import('views/diskm/DiskMe')
const DiskFile = () => import('views/diskm/DiskFile')
const DiskShare = () => import('views/diskm/DiskShare')
const CamList = () => import('views/diskm/CamList')
const CamDetail = () => import('views/diskm/CamDetail')

export default {
  path: '/disk',
  name: 'Disk',
  component: Disk,
  redirect: '/disk/file',
  meta: { needAuth: true, roles: ['tnb_disk'] },
  children: [
    {
      path: '/disk/file',
      name: 'DiskFile',
      component: DiskFile,
      meta: { title: '我的文件', needAuth: true, roles: ['tnb_disk'] }
    },
    {
      path: '/disk/photo',
      name: 'DiskPhoto',
      component: DiskPhoto,
      meta: { title: '我的相册', needAuth: true, roles: ['tnb_disk'] }
    },
    {
      path: '/disk/cam',
      name: 'CamList',
      component: CamList,
      meta: { title: '我的监控', needAuth: true, roles: ['tnb_disk'] }
    },
    {
      path: '/disk/cam/detail',
      name: 'CamDetail',
      component: CamDetail,
      meta: { needAuth: true, roles: ['tnb_disk'] }
    },
    {
      path: '/disk/share',
      name: 'DiskShare',
      component: DiskShare,
      meta: { title: '我的分享', needAuth: true, roles: ['tnb_disk'] }
    },
    {
      path: '/disk/me',
      name: 'DiskMe',
      component: DiskMe,
      meta: { title: '我的', needAuth: true, roles: ['tnb_disk'] }
    }
  ]
}
